<template>
  <div v-if="order?.invoice?.insuranceID" class="w-full h-full flex justify-center items-center pending">
    <div
        class="flex h-8 w-full items-center justify-center rounded-2xl border border-input bg-background px-3 py-2 text-sm ring-offset-background data-[placeholder]:text-muted-foreground focus:outline-none focus:ring-1 focus:ring-ring focus:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-50 [&>span]:truncate"
        :class="{
              '!bg-[#D1F1BB]': value == 'paid',
              '!bg-[#FFE072]': value == 'partialPay',
              '!bg-[#FCC5C5]': value == 'notPaid',
              '!bg-[#FFFFFF] border-red-500 text-red-500': value == 'returned',
               }">
      {{ label }}
    </div>
  </div>
  <div v-else class="flex justify-center">-</div>
</template>
<script lang="ts">
import {defineComponent, ref} from 'vue'
import {useContext} from "@/plugins/context";
import {i18nOrderMessages, Order} from "@/models/sales/Order";
import {useI18n} from "vue-i18n";

export default defineComponent({
  setup() {
    const ctx = useContext();
    const { t } = useI18n({
      messages: {
        en: { ...i18nOrderMessages.en},
        ar: { ...i18nOrderMessages.ar}
      }
    })

    const order = ref<Order | null>(null);
    const value = ref<string>("")
    const label = ref<string>("")

    return {
      ctx,
      t,
      order,
      value,
      label
    }
  },
  props: ['data'],
  mounted() {
    /* @ts-ignore */
    this.order = (this.params?.data || this.$props.data) as Order;
    if (!this.order) {
      return;
    }

    if (this.order.orderItems.filter((oi) => oi.quantity == oi.returnedQuantity).length > 0) {
      this.value = 'returned'
      this.label = this.t('paymentStatus.returned')
      return;
    }

    if (this.order.invoice.insuranceTotalPaidAmount > 0 && this.order.invoice.insuranceTotalDueAmount != this.order.invoice.insuranceTotalPaidAmount) {
      this.value = 'partialPay'
      this.label = this.t('paymentStatus.partialPay')
      return;
    }

    if (this.order.invoice.insuranceTotalPaidAmount == this.order.invoice.insuranceTotalDueAmount) {
      this.value = 'paid'
      this.label = this.t('paymentStatus.paid')
      return;
    }

    if (this.order.invoice.insuranceTotalPaidAmount == 0) {
      this.value = 'notPaid'
      this.label = this.t('paymentStatus.notPaid')
      return;
    }
  }
})
</script>
